export const CHOOSE_OPTIONS = [
  {
    value: 'd',
    label: 'Load.Task.ConditionsWhenLabelDays'
  },
  {
    value: 'w',
    label: 'Load.TriggersDetail.Weeks'
  },
  {
    value: 'm',
    label: 'Load.TriggersDetail.Month'
  },
  {
    value: 'y',
    label: 'Load.TriggersDetail.Years'
  }
]

export const MONTHS = [
  {
    value: '1',
    label: 'Load.MailupCommon.January'
  },
  {
    value: '2',
    label: 'Load.MailupCommon.February'
  },
  {
    value: '3',
    label: 'Load.MailupCommon.March'
  },
  {
    value: '4',
    label: 'Load.MailupCommon.April'
  },
  {
    value: '5',
    label: 'Load.MailupCommon.May'
  },
  {
    value: '6',
    label: 'Load.MailupCommon.June'
  },
  {
    value: '7',
    label: 'Load.MailupCommon.July'
  },
  {
    value: '8',
    label: 'Load.MailupCommon.August'
  },
  {
    value: '9',
    label: 'Load.MailupCommon.September'
  },
  {
    value: '10',
    label: 'Load.MailupCommon.October'
  },
  {
    value: '11',
    label: 'Load.MailupCommon.November'
  },
  {
    value: '12',
    label: 'Load.MailupCommon.December'
  }
]

export const EVERY_HOUR_OPTIONS = [
  {
    label: 'Load.MailupCommon.Every12Hours',
    value: 12 * 60
  },
  {
    label: 'Load.MailupCommon.Every8Hours',
    value: 8 * 60
  },
  {
    label: 'Load.MailupCommon.Every4Hours',
    value: 4 * 60
  },
  {
    label: 'Load.MailupCommon.Every2Hours',
    value: 2 * 60
  },
  {
    label: 'Load.MailupCommon.EveryHour',
    value: 60
  },
  {
    label: 'Load.MailupCommon.Every30minutes',
    value: 30
  },
  {
    label: 'Load.MailupCommon.Every15minutes',
    value: 15
  },
  {
    label: 'Load.MailupCommon.Every5minutes',
    value: 5
  }
]

export const DAYS = [
  {
    value: 'MO',
    label: 'Load.MailupCommon.Monday'
  },
  {
    value: 'TU',
    label: 'Load.MailupCommon.Tuesday'
  },
  {
    value: 'WE',
    label: 'Load.MailupCommon.Wednesday'
  },
  {
    value: 'TH',
    label: 'Load.MailupCommon.Thursday'
  },
  {
    value: 'FR',
    label: 'Load.MailupCommon.Friday'
  },
  {
    value: 'SA',
    label: 'Load.MailupCommon.Saturday'
  },
  {
    value: 'SU',
    label: 'Load.MailupCommon.Sunday'
  }
]

export const EVERY_OPTIONS = [
  {
    value: 'FIRST',
    label: 'Load.MailupCommon.First'
  },
  {
    value: 'SECOND',
    label: 'Load.MailupCommon.Second'
  },
  {
    value: 'THIRD',
    label: 'Load.MailupCommon.Third'
  },
  {
    value: 'FOURTH',
    label: 'Load.MailupCommon.Fourth'
  },
  {
    value: 'LAST',
    label: 'Load.MailupCommon.Last'
  }
]

export const ACTIVITY_OPTIONS = [
  {
    value: 'FromDate',
    label: 'Load.Task.FrequencyActivityFromDate'
  },
  {
    value: 'FromToDate',
    label: 'Load.Task.FrequencyActivityFromToDate'
  }
]
